















import { defineComponent, computed, watch, ref } from "@vue/composition-api";
import { getStore } from "./store";
import { useRouter } from "./router";
import { init as initI18n } from './i18n';

export default defineComponent({
    props: {
        lang: {
            type: String
        },
        isdevelopment: {
            type: Boolean
        }
    },

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        let i18n = initI18n();

        var lang = route.value.params.lang || props.lang;
        if (lang) {
            store.commit('setLang', props.lang);
            i18n.locale = lang;
        }
        store.commit('setIsDevelopment', props.isdevelopment);

        const isLoading = computed(() => {
            return store.state.isLoading > 0;
        });

        return {
            isLoading
        };
    }
});
